import { useVoiceRecorder } from '../hooks/useVoiceRecorder';
import { useToast } from './Toast';

interface VoiceRecorderProps {
  onTranscribed: (text: string) => void;
}

export function VoiceRecorder({ onTranscribed }: VoiceRecorderProps) {
  const { recording, transcribing, startRecording, stopAndTranscribe } = useVoiceRecorder();
  const { addToast } = useToast();

  const handleClick = async () => {
    if (recording) {
      const result = await stopAndTranscribe();
      if (result?.text) onTranscribed(result.text);
    } else {
      try {
        await startRecording();
      } catch (err) {
        const message = err instanceof DOMException && err.name === 'NotAllowedError'
          ? 'Microphone access denied. Please allow microphone in browser settings.'
          : err instanceof Error
          ? err.message
          : 'Could not start recording';
        addToast(message, 'error');
      }
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={transcribing}
      className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors ${
        recording
          ? 'bg-red-500/15 text-red-500 animate-pulse'
          : transcribing
          ? 'bg-ink/5 text-ink/30'
          : 'bg-ink/5 text-ink/40 hover:bg-ink/10'
      }`}
      title={recording ? 'Stop recording' : transcribing ? 'Transcribing...' : 'Voice input'}
    >
      {transcribing ? '⏳' : '🎙️'}
    </button>
  );
}
